import React, { useState, useEffect } from 'react';
import "./Connect.css";

const Connect = () => {
  const matchedJobsCount = 0; // placeholder
  const messageCount = 0; // placeholder
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  return (

<div className="ssf-dashboard">
  <div className="ssf-grid">

    <div
      className="ssf-card"
      onClick={() => {
        setPopupMessage("No competitions are running");
        setShowPopup(true);
      }}
    >
      <div className="ssf-card-icon">🏆</div>
      <h3>Competitions and Rewards</h3>
      <p>{matchedJobsCount} Competitions running</p>
    </div>


    <div
      className="ssf-card"
      onClick={() => {
        setPopupMessage("No projects are displayed");
        setShowPopup(true);
      }}
    >
      <div className="ssf-card-icon">🔍</div>
      <h3>Local Projects</h3>
      <p>No Projects displayed</p>
    </div>

    <div
      className="ssf-card"
      onClick={() => {
        setPopupMessage("No sign up available");
        setShowPopup(true);
      }}
    >
      <div className="ssf-card-icon">🏗️</div>
      <h3>Community Work</h3>
      <p>No sign up available</p>
    </div>

    <div
      className="ssf-card"
      onClick={() => {
        setPopupMessage("No upcoming events");
        setShowPopup(true);
      }}
    >
      <div className="ssf-card-icon">📅</div>
      <h3>Events</h3>
      <p>{messageCount} Upcoming events</p>
    </div>
  </div>

  {showPopup && (
    <div className="custom-popup">
      <div className="popup-content">
        <p>{popupMessage}</p>
        <button onClick={() => setShowPopup(false)}>OK</button>
      </div>
    </div>
  )}
</div>




    
  );
};

export default Connect;
{/*
    <div className="ssf-dashboard">
      

      <div className="ssf-grid">
        <div
          className="ssf-card"
          onClick={() => alert("Navigate to Update Profile")}
        >
          <div className="ssf-card-icon">🔍</div>
          <h3>Local Projects</h3>
          <p>No Projects displayed</p>
        </div>

        <div
          className="ssf-card"
          onClick={() => alert("Navigate to Job Search")}
        >
          <div className="ssf-card-icon">🏗️</div>
          <h3>Community Work</h3>
          <p>No sign up available</p>
        </div>

        <div
          className="ssf-card"
          onClick={() => alert("Scroll to Jobs Matched")}
        >
          <div className="ssf-card-icon">🏆</div>
          <h3>Competitions and Rewards</h3>
          <p>{matchedJobsCount} Competitions running</p>
        </div>

        <div
          className="ssf-card"
          onClick={() => alert("Scroll to Messages")}
        >
          <div className="ssf-card-icon">📅</div>
          <h3>Events</h3>
          <p>{messageCount} Upcoming events</p>
        </div>
      </div>

     
    </div>

    */}